import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { NotificationPreferences as PreferencesType } from "@/hooks/useNotificationPreferences";

interface NotificationPreferencesProps {
  preferences: PreferencesType;
  loading: boolean;
  onUpdatePreference: (key: keyof PreferencesType, value: boolean) => void;
}

const notificationTypes = [
  {
    key: 'new_matches' as const,
    label: 'New Matches',
    description: 'When someone likes you back'
  },
  {
    key: 'new_messages' as const,
    label: 'New Messages',
    description: 'When you receive a message'
  },
  {
    key: 'profile_views' as const,
    label: 'Profile Views',
    description: 'When someone views your profile'
  },
  {
    key: 'event_reminders' as const,
    label: 'Event Reminders',
    description: 'Reminders for upcoming events'
  },
  {
    key: 'system_notifications' as const,
    label: 'System Notifications',
    description: 'Important app updates and announcements'
  }
];

const NotificationPreferences = ({ 
  preferences, 
  loading, 
  onUpdatePreference 
}: NotificationPreferencesProps) => {
  return (
    <div className="space-y-4">
      <Label className="text-sm font-medium">Notification Types</Label>
      
      <div className="space-y-3">
        {notificationTypes.map(({ key, label, description }) => (
          <div key={key} className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label htmlFor={key} className="text-sm">{label}</Label>
              <p className="text-xs text-muted-foreground">{description}</p>
            </div>
            <Switch
              id={key}
              checked={preferences[key]}
              onCheckedChange={(checked) => onUpdatePreference(key, checked)}
              disabled={loading}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationPreferences;